// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"BookingFilter_pageTitle__1B_xj"};